export default __webpack_public_path__ + "static/network-1-c53747f6f4f6c7aefca58b5de441d122.png";